import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Reply from './icon-reply.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Reply {...validProps} />;
}
SvgComponent.iconName = 'reply';

/**
 * @deprecated This is a legacy icon
 */
export const ReplyIcon = svgIconWrapper(SvgComponent);
